/*tslint:disable:max-line-length*/

import { PermissionEnum, RolePermission } from '@/models/DestinationRole';

export class PermissionService {
  private passengerRead = [
    RolePermission.ReadPassengers, 
    RolePermission.ReadAllPassengerTrips, 
    RolePermission.UpdatePassengerGroups,
  ];
  private passengerWrite = [RolePermission.CreatePassengers, RolePermission.UpdatePassengers];
  private passengerPermissions = this.passengerRead.concat(this.passengerWrite);

  private timetableRead = [RolePermission.ReadTimetables];
  private timetableWrite = [
      RolePermission.CreateTimetables,
      RolePermission.UpdateTimetables,
      RolePermission.DeleteTimetables,
  ];

  private arrivalRead = [RolePermission.ReadArrivalDepartures];
  private arrivalWrite = [RolePermission.UpdateArrivalDepartures];
  
  private bookingRead = [RolePermission.ReadBookings];
  private bookingWrite = [
      RolePermission.CreateBookings,
      RolePermission.UpdateBookings,
      RolePermission.DeleteBookings,
  ];

  private transportationPermissionRead = [RolePermission.ReadTransportationPermissions];
  private transportationPermissionWrite = [
      RolePermission.CreateTransportationPermissions,
      RolePermission.UpdateTransportationPermissions,
      RolePermission.DeleteTransportationPermissions,
  ];

  getPassengerPermissionLevel(permissions: RolePermission[]) {
    const writePermissionRequired = permissions.some(p => this.passengerWrite.some(w => w === p));
    if (writePermissionRequired) {
      return PermissionEnum.Write;
    }
    const readPermissionRequired = permissions.some(p => this.passengerRead.some(r => r === p));
    if (readPermissionRequired) {
      return PermissionEnum.Read;
    }
    return PermissionEnum.NoPermission;
  }

  getTimetablePermissionLevel(permissions: RolePermission[]) {
    const writePermissionRequired = permissions.some(p => this.timetableWrite.some(w => w === p));
    if (writePermissionRequired) {
      return PermissionEnum.Write;
    }
    const readPermissionRequired = permissions.some(p => this.timetableRead.some(r => r === p));
    if (readPermissionRequired) {
      return PermissionEnum.Read;
    }
    return PermissionEnum.NoPermission;
  }

  getArrivalPermissionLevel(permissions: RolePermission[]) {
    const writePermissionRequired = permissions.some(p => this.arrivalWrite.some(w => w === p));
    if (writePermissionRequired) {
      return PermissionEnum.Write;
    }
    const readPermissionRequired = permissions.some(p => this.arrivalRead.some(r => r === p));
    if (readPermissionRequired) {
      return PermissionEnum.Read;
    }
    return PermissionEnum.NoPermission;
  }

  getBookingPermissionLevel(permissions: RolePermission[]) {
    const writePermissionRequired = permissions.some(p => this.bookingWrite.some(w => w === p));
    if (writePermissionRequired) {
      return PermissionEnum.Write;
    }
    const readPermissionRequired = permissions.some(p => this.bookingRead.some(r => r === p));
    if (readPermissionRequired) {
      return PermissionEnum.Read;
    }
    return PermissionEnum.NoPermission;
  }

  getTransportationPermissionLevel(permissions: RolePermission[]) {
    const writePermissionRequired = permissions.some(p => this.transportationPermissionWrite.some(w => w === p));
    if (writePermissionRequired) {
      return PermissionEnum.Write;
    }
    const readPermissionRequired = permissions.some(p => this.transportationPermissionRead.some(r => r === p));
    if (readPermissionRequired) {
      return PermissionEnum.Read;
    }
    return PermissionEnum.NoPermission;
  }

  getRideitPermissionLevel(permissions: RolePermission[]) {
    const writePermissionRequired = permissions.some(p => p === RolePermission.WriteRideitTokens);
    if (writePermissionRequired) {
      return PermissionEnum.Write;
    }
    const readPermissionRequired = permissions.some(p => p === RolePermission.ReadRideitTokens);
    if (readPermissionRequired) {
      return PermissionEnum.Read;
    }
    return PermissionEnum.NoPermission;
  }

}

export default new PermissionService();
